import Vue from 'vue'
import VueRouter from "vue-router";
import Home from "@/pages/Home";
import Tentang from "@/pages/Tentang";
import Laporan from "@/pages/Laporan";
import Peta from "@/pages/Peta";

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home, name: 'Home'},
  { path: '/tentang', component: Tentang, name: 'Tentang' },
  { path: '/laporan', component: Laporan, name: 'Laporan' },
  { path: '/peta', component: Peta, name: 'Peta' }
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  mode: 'history'
})

export default router
